import React from 'react';
export function PainPoints() {
  const points = ['El domingo a la noche buscando cómo explicar el FCR o el ciclo del nitrógeno con un lenguaje que tus alumnos entiendan sin dormirse', 'Estudiantes que salen del curso sin saber distinguir una trucha de un bagre ni calcular la tasa de alimentación de un estanque', 'Material que no se corresponde con las especies, los sistemas ni los mercados donde tus alumnos van a trabajar', 'Fines de semana enteros armando planillas, tablas de alimentación y evaluaciones que nadie te enseñó a diseñar', 'Esa sensación de que estás improvisando en un sector donde una mala decisión técnica puede significar la pérdida de todo el lote'];
  const tried = [{
    t: 'Manuales técnicos universitarios:',
    d: 'Pura biología. Sin actividades, sin evaluaciones, sin ejemplos aplicados al aula técnica.'
  }, {
    t: 'Papers y artículos científicos:',
    d: 'Excelentes para investigadores. Inútiles para el docente que tiene clase el lunes.'
  }, {
    t: 'Material de organismos internacionales:',
    d: 'Genérico, desactualizado y sin estructura pedagógica real.'
  }, {
    t: 'Grupos de WhatsApp de docentes:',
    d: 'Material suelto, sin progresión, sin contexto productivo. Te pasan una hoja y tenés que armar el resto solo.'
  }, {
    t: 'Tus propias notas y adaptaciones:',
    d: 'Horas de trabajo tuyo que podrían estar dedicadas a tus alumnos, a tu familia o a descansar.'
  }];
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase leading-tight mb-5" data-id="element-125">
          Si enseñás{' '}
          <span className="yellow-highlight" data-id="element-126">
            Acuicultura, Piscicultura o Producción Acuícola
          </span>
          , esto te va a sonar muy familiar:
        </h2>

        <div className="bg-white border-2 border-brand-navy rounded-lg p-4 md:p-5 brunson-shadow mb-5" data-id="element-127">
          <ul className="space-y-2.5" data-id="element-128">
            {points.map((p, i) => <li key={i} className="flex items-start gap-2" data-id="element-129">
                <span className="text-brand-red text-lg leading-none mt-0.5" data-id="element-130">
                  ❌
                </span>
                <p className="text-sm md:text-base text-brand-ink font-medium leading-snug" data-id="element-131">
                  {p}
                </p>
              </li>)}
          </ul>
        </div>

        <p className="text-center text-xl md:text-3xl font-display font-bold text-brand-red uppercase mb-6" data-id="element-132">
          ¿Cuántos domingos más vale tu tiempo libre?
        </p>

        <h3 className="text-xl md:text-3xl font-display font-bold text-brand-navy text-center uppercase mb-4 leading-tight" data-id="element-133">
          Lo que ya intentaste —{' '}
          <span className="yellow-highlight" data-id="element-134">y por qué no fue suficiente:</span>
        </h3>

        <div className="bg-white border-2 border-brand-navy rounded-lg p-4 md:p-5 brunson-shadow mb-5" data-id="element-135">
          <ul className="space-y-2.5" data-id="element-136">
            {tried.map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-137">
                <span className="text-brand-red font-black mt-0.5" data-id="element-138">✗</span>
                <p className="text-sm md:text-base text-brand-ink leading-snug" data-id="element-139">
                  <span className="font-bold text-brand-navy" data-id="element-140">{t.t}</span> {t.d}
                </p>
              </li>)}
          </ul>
        </div>

        <p className="text-center text-base md:text-xl font-bold text-brand-ink leading-tight" data-id="element-141">
          El problema no es que te falte información sobre acuicultura.{' '}
          <span className="text-brand-red block md:inline" data-id="element-142">
            Es que nunca tuviste un sistema didáctico completo.
          </span>
        </p>
      </div>
    </section>;
}